const ON_CHANGE_DEBOUNCE_TIMER = 100; // Reduced from 150ms for better responsiveness

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
